// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const butterfree: PokeData = {
  "id": 12,
  "name": "butterfree",
  "height": 11,
  "weight": 320,
  "base_experience": 178,
  "types": [
    PokeType.BUG,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "whirlwind",
    "tackle",
    "supersonic",
    "psybeam",
    "poison-powder",
    "stun-spore",
    "sleep-powder",
    "string-shot",
    "confusion",
    "harden",
    "safeguard",
    "silver-wind",
    "tailwind",
    "air-slash",
    "bug-buzz",
    "captivate",
    "bug-bite",
    "rage-powder",
    "quiver-dance"
  ],
  "moves": [
    "gust",
    "tackle",
    "supersonic",
    "poison-powder",
    "stun-spore",
    "string-shot",
    "tailwind",
    "air-slash",
    "bug-buzz",
    "bug-bite",
    "hurricane",
    "pin-rush",
    "pin-missile"
  ],
  "evolution_chain": {
    "id": 4,
    "item": null,
    "species": [
      {
        "name": "caterpie",
        "order": 10,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "metapod",
        "order": 11,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": 10,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 7,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "butterfree",
        "order": 12,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 11,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 10,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 112,
    "speed": 126,
    "ability_power": 162
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
